import { related, sourceIds } from './puzzles__atlantis-code-the-park.mdx';

export { sourceIds, related };
export const quickAnswer = 'The Park 的 Atlantis 餐厅收银机密码为 BDAC。';

## 对应哪个 Atlantis

使用 The Park 的 Atlantis 餐厅收银机。Downtown 的同名餐厅需要操作七个物件，攻略不能互换。

## 输入字母顺序

依次输入 B、D、A、C。完成后检查隐藏墙并进入秘密藏身处，收集生命升级物品。

## 输入后没反应

先确认是公园区域，再检查是否完整输入四个字母。市中心步骤见 [Downtown 餐厅解谜](/puzzles/atlantis-restaurant-downtown)。
